import React, { useState, useRef, useEffect } from "react";
import { Item, GridInput, Arrow } from "./EditableGridStyles";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import arrow from "../../icons/rightAngle.svg";

const GridItem = (props) => {
  const {
    value,
    onChange,
    name,
    children,
    editable,
    isOdd,
    formatVal,
    row,
    col,
    inputType
  } = props;
  const [editActive, setEditActive] = useState(false);
  const inputRef = useRef(null);

  useOutsideClick(inputRef, () => setEditActive(false));

  useEffect(() => {
    function handleEnter(e) {
      if (e.key === "Enter") setEditActive(false);
    }
    window.addEventListener("keypress", handleEnter);
    return () => {
      window.removeEventListener("keypress", handleEnter);
    };
  }, []);

  const val = formatVal ? formatVal(value, { row, col }) : value;

  const input = (
    <GridInput
      ref={inputRef}
      value={val}
      name={name}
      onChange={onChange}
      type={inputType || 'text'}
    />
  );

  const text = (
    <div
      style={{ paddingLeft: 10, height: 40 }}
      onDoubleClick={editable ? () => setEditActive(true) : null}
    >
      {children || val}
      {editable && <Arrow title="Double click to edit" src={arrow} alt="" />}
    </div>
  );

  return <Item isOdd={isOdd}>{editActive ? input : text}</Item>;
};

export default GridItem;
